import styled, { css } from 'styled-components';
import { livePageResponsiveWithSidebar } from '../styled/utils';

export const ContentWrapper = styled.div`
    width: ${({ $width }) => $width || '100%'};
    min-height: calc(100vh - 120px);
    padding-inline: ${({ isLeftSideBarOpen }) =>
        isLeftSideBarOpen ? '16px' : '91px'};
    background-color: ${({ theme }) => theme.bg.neutralGrey};
    padding-block: 16px 30px;
    box-sizing: border-box;
    overflow: hidden;
    transition: padding 0.3s ease;

    @media screen and (max-width: 1440px) {
        padding-inline: ${({ isLeftSideBarOpen }) =>
            isLeftSideBarOpen ? '16px' : '50px'};
        padding-block: 13px 30px;
    }

    @media screen and (max-width: 1040px) {
        padding-inline: 16px;
    }

    ${({ isMobile }) =>
        isMobile &&
        css`
            padding-inline: 0;

            @media screen and (max-width: 1040px) {
                padding-inline: 0;
                padding-block: 16px 30px;
            }
        `};
`;

export const LivePageContentWrapper = styled(ContentWrapper)`
    padding-inline: ${({ isLeftSideBarOpen }) =>
        isLeftSideBarOpen ? '16px' : '16px 26px'};
    padding-top: 0;

    ${({ isLeftSideBarOpen }) =>
        livePageResponsiveWithSidebar(
            isLeftSideBarOpen,
            css`
                padding-inline: ${({ isLeftSideBarOpen }) =>
                    isLeftSideBarOpen ? '16px' : '50px'};
                padding-block: 16px 30px;
            `
        )};

    @media screen and (max-width: 1040px) {
        padding-inline: 16px;
    }

    ${({ isMobile }) =>
        isMobile &&
        css`
            padding-inline: 0;

            @media screen and (max-width: 1040px) {
                padding-inline: 0;
            }
        `};
`;

export const ContentBlock = styled.div`
    position: relative;
    width: 100%;
    max-width: 1109px;
    margin: 0 auto;
`;
